import React from "react";
import { Box, Typography, Button, Grid, Link } from "@mui/material";
import FormDrawer from "../../components/layout/FormDrawer";
import { BRAND } from "../../components/auth/authTheme";
import { IMAGE_URL } from "../../services/api";

const DetailRow = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" sx={{ color: BRAND.muted, display: "block", mb: 0.5 }}>
      {label}
    </Typography>
    <Typography variant="body2" sx={{ color: BRAND.navy, fontWeight: 500 }}>
      {value || "—"}
    </Typography>
  </Grid>
);

const ViewLeaveModal = ({ show, handleClose, selectedLeave, isEmployee }) => {
  const status = selectedLeave?.approval_status || "pending";

  return (
    <FormDrawer
      open={show}
      onClose={handleClose}
      title="Leave Details"
      subtitle="Review leave request information"
      footer={
        <Button onClick={handleClose} variant="contained" color="primary" fullWidth>
          Close
        </Button>
      }
    >
      {selectedLeave ? (
        <Box>
          <Box sx={{ mb: 2 }}>
            <span className={`leave-status-badge ${status}`}>{status}</span>
          </Box>
          <Grid container spacing={2.5}>
            {!isEmployee && (
              <>
                <DetailRow label="Employee ID" value={selectedLeave.employee_id} />
                <DetailRow label="Employee" value={selectedLeave.employee} />
              </>
            )}
            <DetailRow
              label="Leave Type"
              value={
                selectedLeave.leave_type
                  ? selectedLeave.leave_type.charAt(0).toUpperCase() +
                    selectedLeave.leave_type.slice(1)
                  : ""
              }
            />
            <DetailRow
              label="Leave Dates"
              value={`${selectedLeave.leave_start_date} – ${selectedLeave.leave_end_date}`}
            />
            <DetailRow
              label="Total Days"
              value={selectedLeave.total_leave_days}
            />
            <Grid item xs={12}>
              <Typography
                variant="caption"
                sx={{ color: BRAND.muted, display: "block", mb: 0.5 }}
              >
                Reason
              </Typography>
              <Typography variant="body2" sx={{ color: BRAND.text, lineHeight: 1.6 }}>
                {selectedLeave.reason || "—"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="caption"
                sx={{ color: BRAND.muted, display: "block", mb: 0.5 }}
              >
                Attachments
              </Typography>
              {selectedLeave.attachments?.length ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 1 }}>
                  {selectedLeave.attachments.map((file, index) => {
                    const fileName = typeof file === 'string' ? file.split('/').pop() : `Attachment ${index + 1}`;
                    return (
                      <Box
                        key={index}
                        component="a"
                        href={`${IMAGE_URL}${file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          p: 1.5,
                          border: `1px solid ${BRAND.border}`,
                          borderRadius: "10px",
                          bgcolor: "#fafafa",
                          textDecoration: "none",
                          "&:hover": {
                            bgcolor: BRAND.orangeLight,
                            borderColor: BRAND.orangeHover,
                          },
                        }}
                      >
                        <Box sx={{ color: BRAND.orange, display: "flex", alignItems: "center", mr: 2 }}>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                          </svg>
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{
                            color: BRAND.navy,
                            fontWeight: 500,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {fileName}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Typography variant="body2" sx={{ color: BRAND.muted }}>
                  No attachments
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>
      ) : null}
    </FormDrawer>
  );
};

export default ViewLeaveModal;
